import { createQueryClient } from '@mint-lib/query-client';

export const queryClient = createQueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
